module.exports = __webpack_public_path__ + "static/four-989c53b77efc795e30877306fd000081.mp4";